import React from "react";
import {AccessibleReactSelect} from "../../../../../components/AccessibleReactSelect/AccessibleReactSelect";
import {customStyles} from "./commons";

function ReactSelect(props) {
    return (
        <AccessibleReactSelect
            {...props}
            onChange={(value) => {
                props.onChange({
                    target: {
                        value,
                        name: props.name,
                    },
                });
            }}
            onBlur={() => {
                props.onBlur({
                    target: {
                        name: props.name,
                    },
                });
            }}
        />
    );
}

ReactSelect.defaultProps = {
    isClearable: true,
    styles: customStyles,
};

export default ReactSelect;
